import { Component, OnInit } from '@angular/core';
//import { HandleError } from 'src/app/shared/HandleError';
import swal from 'sweetalert2';
import { RegistrationService } from '../../registration.service';
import { HandleError } from '../../shared/HandleError';
import { Alert } from 'selenium-webdriver';
import { FormGroup, FormControl, NgForm } from '@angular/forms';
declare var $: any;



@Component({
  selector: 'app-dependents-document-uploads',
  templateUrl: './dependents-document-uploads.component.html',
  styleUrls: ['./dependents-document-uploads.component.css']
})
export class DependentsDocumentUploadsComponent implements OnInit {

 // cancel: any;
 
  formInvalid: boolean = false;
  dep_data: any; 
  data:any;
  s: any = {}; 
 // title = "Details of Dependents";
  mode: string = "save";
  isSainikExist: boolean = false;   
  display = 'none';
  UserName: string;
  RoleName: string;  
  Uploads:any[] = [];
  fileToUpload: File = null;
  imageUrl: string = "assets/images/image-default.png";  
  d:any;
  depResult:any; 
  u: any = {};
  itemQuantity = [];
  //new 
  su:any= {};
  DocumentTypes:any[] = [];
  req_service_no :any;
  req_sd_id: any;  
  //below three fields are displaing on label
  Sainik_Name: any;
  Dependent_Name:any;
  Relation_Name: any;
  SR_Id:any;   
  url: string | ArrayBuffer;
  response: any =[] ;

  constructor(private service : RegistrationService,private handleError:HandleError) {
   }

  ngOnInit() {
    this.itemQuantity = Array(10).fill(0).map((x,i)=>i+1);
    this.GetAllDocumentTypesDep();
    this.UserName=localStorage.getItem('userName');
    this.RoleName=localStorage.getItem('userRole');
    if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
    this.s.SR_ServiceNo=this.UserName;
    //alert('ng onit :' +this.s.SR_ServiceNo)
    }
    
  }  

  GetAllDependentsBySainikId(SR_ServiceNo:any){
    //alert(SR_ServiceNo)
    this.req_service_no=SR_ServiceNo;
    this.service.GetAllDependentsBySainikId(SR_ServiceNo).subscribe((data)=>{
    this.dep_data = data
    //console.log("Dependent data :", JSON.stringify(this.dep_data))
    })
   }

   GetDependentDetailById($event){ 
    this.req_sd_id=$event.target.value;   
     //alert(this.req_service_no);
     //alert(this.req_sd_id);
      this.service.GetDependentDetailById(this.req_service_no,this.req_sd_id).subscribe((data)=>{
      this.depResult = data 
      this.Sainik_Name=this.depResult.Sainik_Name;
      this.Dependent_Name=this.depResult.Dependent_Name;
      this.Relation_Name=this.depResult.Relation_Name; 
      this.SR_Id=this.depResult.SR_Id;  // this is globally accessed and used during the file upload     
      //console.log("GetDependentDetailById",JSON.stringify( this.depResult))
      //console.log("sr id :",this.SR_Id)
      this.GetDependentDocDetail_Grid(this.SR_Id,this.req_sd_id);
    })    
    }   
 
  GetDependentDocDetail_Grid(SR_Id,SD_Id)
  {      
    this.service.GetDependentDocDetail_Grid(SR_Id,SD_Id).subscribe((data)=>{
    this.response = data 
    
    //console.log('grid data :' +JSON.stringify(this.response))     
    
    for (let i = 0; i < this.Uploads.length; i++) {
      //this.ng.IsSelected=false;
      this.s.SDU_File=this.Uploads[i].SDU_File;
     // su.value.SDU_DT_Id_FK=this.Uploads[i].SDU_DT_Id_FK;
    //su.value.SDU_Category=this.Uploads[i].SDU_Category;
      //su.value.SDU_Category="AAdhar";//ref hardcoded
    }

    if(this.response.length!=0){
    //console.log('inside')
    this.Uploads=this.response;
    this.isSainikExist = true;   
    this.mode = "update";
            
    }
    
    else{
      this.Uploads = []; 
      this.isSainikExist = true;   
    }      
    }, (error) => {
      console.log(error);
      document.getElementById('loader-spinner').style.display = "none";
      if (error.status == 400)
      //swal('Warning!', 'Sainik does not exist.', 'warning');
      //swal('Warning!', 'Sainik does not belong to this district.', 'warning');
      swal('Warning!', 'Please fill all the Details.', 'warning');
      // else if(error.status == 401)
      //   swal('Warning!', 'Not authorized to access this page.', 'warning');
      this.handleError.ErrorHandler(error);
    }
    
    ) 

  }

  SaveDependentUploads(su: NgForm){
      // alert ('SaveSainikUploads hit');
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";       
      su.value.SDU_File=this.getImage();  

        for (let i = 0; i < this.Uploads.length; i++) {         
          su.value.SDU_File=this.Uploads[i].SDU_File;
          su.value.SDU_DT_Id_FK=this.Uploads[i].SDU_DT_Id_FK;
          su.value.SDU_Category=this.Uploads[i].SDU_Category;
          su.value.SDU_PageNo=this.Uploads[i].SDU_PageNo;
          su.value.SDU_DocNo=this.Uploads[i].SDU_DocNo;         
        }              
        //console.log("upload data :" +JSON.stringify(this.Uploads)); 
        this.service.SaveDependentsDocUploads(this.Uploads,this.SR_Id,this.req_sd_id)
        .subscribe((data) => {
        //console.log("after  upload data :" +JSON.stringify(this.data));
        //alert("File uploaded successfully")
        this.Uploads = [];
        this.s.SR_Category="";
        this.u.SDU_Category="";
        this.Sainik_Name="";
        this.Dependent_Name="";
        this.Relation_Name="";
        this.formInvalid = false;
        swal('Success!', 'Depenedents Details Saved Successfully.', 'success');
        document.getElementById('loader-spinner').style.display = "none";
          
      }), (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
        this.handleError.ErrorHandler(error);
      }

      }

  CheckDocumenttype(documenttypename){
    //alert('hit CheckDocumenttype');
    for (let i = 0; i < this.Uploads.length; i++) {
      if (this.Uploads[i].SDU_Category == documenttypename) {
        if(this.Uploads[i].SDU_Category == 'Photo' ||this.Uploads[i].SDU_Category == 'WidowPhoto'|| 
        this.Uploads[i].SDU_Category == 'FingerPrint' ||this.Uploads[i].SDU_Category == 'Signature')
       swal('Already Exist');
      }
    }
  }  
  
  GetAllDocumentTypesDep() {
    //alert('hit getAllDocumentTypesDep');
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.GetAllDocumentTypesDep();
    this.data.subscribe(
    (response) => {
    this.DocumentTypes = response;
    //console.log("GetAllDocumentTypesDep data :", JSON.stringify(this.DocumentTypes))
    document.getElementById('loader-spinner').style.display = "none";
    }, 
      (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
    } 

  getImage() {
    // alert('get Image')
     let imagename = null;
     try {
       imagename = document.getElementById('SDU_File');
       return imagename.files[0].name;
     }
     catch (e) {
       return null;
     }
  } 

  FileInput(file: FileList) {
    //alert('fileinput')    
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.JPG|.JPEG|.PNG)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;     
    if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => { }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.service.uploadImage(data);
    x.subscribe(
    (response) => {  }, (error) => {
      let i: any = document.getElementById('SDU_File');
      i.value = "";
      if (error.status == 400) {         
      swal('Warning!', error.error.Message, 'warning');
      }
      });
     }
     else {
       let i: any = document.getElementById('SDU_File');
       i.value = "";
       if (!uploadedFilename.match(regex))
         swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
       else if (size > 2048)
         swal('Warning!', "Please upload image file less than 2mb", 'warning');
     }
   }
   
  AddDepDoc(u) 
    {
        // alert('AddDepDoc hit')   
        // console.log("AddDepDoc1 :",JSON.stringify(u))
        if (u.SDU_File==undefined || u.SDU_File==null && u.SDU_Category==undefined ||u.SDU_Category==null)
          {   
            swal("Please select the file to upload");        
          }
        else
      {
        let temp = {        
          //categoryname: u.SDU_Category.DT_Name,
          SDU_Id:u.SDU_Id,      
          SDU_Category :u.SDU_Category.DT_Name,
          SDU_DT_Id_FK:this.GetDocumentTypeId(u.SDU_Category.DT_Name), 
          SDU_File:this.getCancelPDFUrl(), 
          SDU_PageNo:u.SDU_PageNo, 
          //serviceNo:this.req_service_no, // sainik no 
          //dependentNo:this.req_sd_id,   // dependent no
          SDU_DocNo:u.SDU_DocNo         
        }    
          this.Uploads.push(temp);
          //console.log("AddDepDoc2 :",JSON.stringify(temp))
          this.closeModalDialog();       
          this.u = {};
      }
    }  

closeModalDialog(){
  $("#DepDocpopup").modal('hide'); 
 }

 GetDocumentTypeId(categoryname) 
 {
  //alert('doctypeid')
  for (let i = 0; i < this.DocumentTypes.length; i++) 
    {
      if (this.DocumentTypes[i].DT_Name == categoryname) 
        {
          let SDU_DT_Id_FK = this.DocumentTypes[i].DT_Id;
          return SDU_DT_Id_FK;
        }
    }
  }
  getCancelPDFUrl() 
  {
  // alert('getCancelPDFUrl')
  let imagename = null;
  try
  {
    imagename = document.getElementById('SDU_File');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
  }
 
  RemoveUploads(i)
  {    
    swal({
      title: 'Are you sure?',
      text: "You want to delete this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        
        var DuploadId = this.Uploads[i].SDU_Id;
        if(DuploadId==undefined || DuploadId==0)
        {
          this.Uploads.splice(i, 1);
        }
        if(DuploadId!=undefined || DuploadId==0){
        document.getElementById('loader-spinner').style.display = "block";
        this.service.DeleteDependentsDocUploads(DuploadId).subscribe(
          (data:any) => {
            console.log('inside')
            swal('','Upload Dependent Deleted!','success');
            this.Uploads.splice(i, 1);
            document.getElementById('loader-spinner').style.display="none";
          },(error) => {
            document.getElementById('loader-spinner').style.display="none";
            this.handleError.ErrorHandler(error);
          });
        }
      }
    })     
  }  

  Cancel(){
    this.u.SDU_Category="";
    this.u.SDU_PageNo="";
    this.u.SDU_File="";
    this.u.SDU_DocNo="";

  }

  ClearForm(){
    this.Uploads = []; 
    this.s.SR_Category="";
    this.u.SDU_Category="";
    this.Sainik_Name="";
    this.Dependent_Name="";
    this.Relation_Name="";  
    this.GetAllDependentsBySainikId('000000');
    //this.DocumentTypes=[];  
   }  
    
    
}



// WEBPACK FOOTER //
// ./src/app/sainik-registration/dependents-document-uploads/dependents-document-uploads.component.ts